import type { TFunction } from 'i18next';
import type { AssessmentResultItemDataFragment } from '../../../Trainee/TraineeReports.api';
import type { CognitiveFitness } from '../../model';
import type { SpatialPlanningAssessmentResultDataFragment } from '@/pages/AssessmentLauncher/SpatialPlanning/SpatialPlanning.api';
import { formatDecimalValue } from '@/utils/common';

const parseSpatialPlanning = (t: TFunction, items: AssessmentResultItemDataFragment[]): CognitiveFitness | null => {
    const item = items.find(i => i.result.__typename === 'SpatialPlanningResult');
    const mi = item?.moduleInstance;
    const r = item?.result as SpatialPlanningAssessmentResultDataFragment;
    if (!mi?.name || !r) {
        return null;
    }

    return {
        name: mi.name ?? '',
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.cognitiveFitness.scoreLabel'),
                value: t('traineeReports:performance.cognitiveFitness.scoreValue', {
                    value: `${formatDecimalValue(r.accuracy ?? 0)}/100`,
                }),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.avgResponseTimeMs'),
                value: `${Math.round(r.averageResponseTimeMs)}`,
            },
        ],
    };
};

export default parseSpatialPlanning;
